export default __webpack_public_path__ + "static/media/33.24255418.svg";